// GraphQLClient type - apps must provide graphql-request implementation
export type GraphQLClientType = {
  request: <R, V extends Record<string, unknown>>(query: string, variables?: V) => Promise<R>;
};

export const gqlClients: Record<string, GraphQLClientType> = {};

export const DEFAULT_LIMIT = 20000;
export const MAX_PAGES = 1000;

export async function gqlHelper<T, V extends Record<string, unknown>, R>(
  GQL_URL: string,
  query: string,
  variablesBuilder: (offset: number, limit: number) => V,
  extractItems: (response: R) => T[],
  GraphQLClientClass: new (url: string) => GraphQLClientType,
  /**
   * @description the limit might be lower, it's estimated by the indexer
   */
  limit: number = DEFAULT_LIMIT,
  maxPages: number = MAX_PAGES,
): Promise<T[]> {
  if (!gqlClients[GQL_URL]) {
    gqlClients[GQL_URL] = new GraphQLClientClass(GQL_URL);
  }
  const gqlClient = gqlClients[GQL_URL];
  let offset = 0;
  let page = 0;
  const allItems: T[] = [];
  let items: T[] = [];
  do {
    const variables = variablesBuilder(offset, limit);
    const data: R = await gqlClient.request<R, V>(query, variables);
    items = extractItems(data) ?? [];
    allItems.push(...items);
    offset += items.length;
    page += 1;
  } while (items.length > 0 && page < maxPages);
  return allItems;
}
